import axios from '@/server/request'
import { Message } from 'element-ui'

const state = {
    // 订阅信息
    subscribeData: {},
    // 渠道列表
    channelOptions: [],
    isChannelLoading: false
}

const mutations = {
    updateSubscribe(state, payload) {
        state.subscribeData = null
        state.subscribeData = payload
    },

    updateChannel(state, payload) {
        state.channelOptions.splice(0)
        state.channelOptions = payload
    },

    updateChannelLoading(state, payload) {
        state.isChannelLoading = payload
    }
}

const actions = {
    // 添加订阅
    async addSubscribe({ commit }, params) {
        try {
            const res = await axios.post({
                url: 'subscribe/save',
                params
            })

            if (res.data.ErrorCode === 200) {
                Message({
                    message: '添加订阅成功',
                    type: 'success'
                })
                return Promise.resolve(res.data.Message)
            } else {
                return Promise.reject(res.data.ErrorMessage)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    // 获取订阅列表
    async fetchSubscribeList({ commit }, params) {
        try {
            const res = await axios.get({
                url: 'subscribe/list',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateSubscribe', res.data.Data)
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    // 搜索渠道
    async fetchChannel({ commit }, params) {
        commit('updateChannelLoading', true)
        try {
            const res = await axios.get({
                url: 'subscribe/searchChannel',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateChannel', res.data.Data)
                commit('updateChannelLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateChannelLoading', false)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters: {},
    mutations,
    actions
}
